import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../common/AutoBindComponent";
import * as types from "../../constants/ComponentConstants";
import * as simulatieDossierActions from "../../actions/simulatieDossierActions";
import * as layoutActions from "../../actions/layoutActions";
import * as beads from "../../actions/beadActions";

import SimulatieInfrastructuurDetailForm from "./SimulatieInfrastructuurDetailForm";
import SimulatieInfrastructuurDetailPageHelper from "./SimulatieInfrastructuurDetailPageHelper";

import convertToLabelValuePair from "../../util/convertToLabelValuePair.js";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";

class SimulatieInfrastructuurDetailPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isNew: false,
            type: 0,
            model_original: null,
            model: null
        };

        this.pageHelper = new SimulatieInfrastructuurDetailPageHelper(this);
    }

    componentWillReceiveProps(nextProps) {
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnChange(event, data) {
        this.pageHelper.change(event, data);
    }

    handleOnSave(event) {
        this.pageHelper.save(event);
    }

    handleOnCancel() {
        this.pageHelper.cancel();
    }

    handleOnReplacePoint(event) {
        this.pageHelper.replacePoint(event);
    }

    handleOnSaveNewPoint() {
        this.pageHelper.saveNewPoint();
    }

    handleOnCancelReplace() {
        this.pageHelper.cancelReplace();
    }

    handleOnGetGeoCoordinates(event) {
        this.pageHelper.getGeoCoordinates(event);
    }

    handleOnDragEnd(e) {
        this.pageHelper.onDragEnd(e);
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        const {
            maxMapFeaturesToLoad,
            osmBaseLayerUrl
        } = this.props;

        return (<SimulatieInfrastructuurDetailForm
            color={types.COLOR_PINK}
            model={this.state.model}
            isNew={this.state.isNew}
            isSpakki={this.state.isSpakki}
            soortenWerken={this.props.soortenWerken}
            soortenInfrastructuur={this.props.soortenInfrastructuur}
            gemeenten={this.props.gemeenten}
            postcodes={this.props.postcodes}
            mapKey={this.state.mapKey}
            mapEditMode={this.state.mapEditMode}
            onChange={this.handleOnChange}
            onSave={this.handleOnSave}
            onCancel={this.handleOnCancel}
            onReplacePoint={this.handleOnReplacePoint}
            mapCenter={this.state.mapCenter}
            mapNewCoords={this.state.mapNewCoords}
            onSaveNewPoint={this.handleOnSaveNewPoint}
            onCancelReplace={this.handleOnCancelReplace}
            onGetGeoCoordinates={this.handleOnGetGeoCoordinates}
            errors={this.props.infrastructuurErrors}
            validationMessageType={this.props.validationMessageType}
            databeheerderTelefoon={this.props.simulatieDossier.item.databeheerderTelefoon}
            databeheerderEmail={this.props.simulatieDossier.item.databeheerderEmail}
            maxMapFeaturesToLoad={maxMapFeaturesToLoad}
            osmBaseLayerUrl={osmBaseLayerUrl}
            onMarkerDragEnd={this.handleOnDragEnd}
        />);
    }
}

SimulatieInfrastructuurDetailPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const simulatieDossierId = state.simulatieDossier.item.id;
    const hideAndereSoortInfrastructuur = !(state.simulatieDossier.item.andereInfrastructurenBeschikbaar === true || state.simulatieDossier.item.andereInfrastructurenBeschikbaar === "true");

    return {
        simulatieDossierId: simulatieDossierId,
        postcodes: convertToLabelValuePair(state.referentie.postcodes),
        gemeenten: convertToLabelValuePair(state.referentie.gemeenten),
        soortenInfrastructuur: hideAndereSoortInfrastructuur ? state.referentie.soortenInfrastructuur.filter((x, i) => i > 0) : state.referentie.soortenInfrastructuur,
        sportinfrastructurenInDeBuurt: state.simulatieDossier.item.sportinfrastructurenInDeBuurt,
        infrastructuurErrors: state.simulatieDossier.infrastructuurErrors,
        validationMessageType: state.simulatieDossier.validationMessageType,
        soortenWerken: convertToLabelValuePair(state.referentie.soortenWerken),
        simulatieDossier: state.simulatieDossier,
        maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
        osmBaseLayerUrl: state.settings.osmBaseLayerUrl
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadSimulatieInfrastructuurDetailPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch),
        saveInfrastructuur: bindActionCreators(simulatieDossierActions.saveSimulatieInfrastructuur, dispatch),
        resetInfrastructuurErrors: bindActionCreators(simulatieDossierActions.resetInfrastructuurErrors, dispatch),
        removeInfrastructuur: bindActionCreators(simulatieDossierActions.removeInfrastructuur, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(SimulatieInfrastructuurDetailPage));